import { UnstyledButtonType } from '@components/SearchBars/SearchFigma/types';
import { TableFilled } from '@components/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createStyles, UnstyledButton } from '@mantine/core';
import { beam } from '@styles/colors/themes';
import { deviceTypes } from '@styles/mediaQueries';
import { zIndexes } from '@styles/zindex/zindex';
import styled from 'styled-components';
import { ReactComponent as VectorGray } from '@assets/svg/vector-gray.svg';
import Text, { TextType } from '@components/Text/Text';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  /* Required for cog. */
  position: relative;
`;

Container.displayName = 'Container';

export const ContainerLoadMore = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;

  width: 100%;
`;
interface IRowDiv {
  isCustomField: boolean;
}

export const RowDiv = styled.div<IRowDiv>`
  display: flex;
  flex-direction: row;
  cursor: ${({ isCustomField }) => (isCustomField ? 'unset' : 'pointer')};
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;

  /* For when the arrow is hidden */
  overflow: hidden;
  text-overflow: ellipsis;
  & > span {
    /* With arrow. */
    text-overflow: ellipsis;
    overflow: hidden;
    font: inherit;
  }
`;

export const Icon = styled(VectorGray)`
  width: 8px;
  height: 10px;
  &[data-direction='up'] {
    transform: rotate(-180deg);
  }
`;
export const FieldHeaderWrap: UnstyledButtonType = styled(UnstyledButton)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  && {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  &[data-disabled='true'] {
    cursor: default;
  }
  &[data-disabled='false'] * {
    cursor: pointer;
  }
  [data-device='${deviceTypes.mobile}'] & {
    & ${Icon} {
      color: var(--beam-color-neutral-n700);
    }
  }
`;
export const Tags = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  text-align: left;
  display: flex;
  flex-direction: column;
`;
export const Tbody = styled.tbody`
  display: block;
`;
export const TbodyTag = styled.tbody`
  display: block;
  height: 340px;
  overflow-y: auto;
  padding: 1px;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
export const Trh = styled.tr`
  width: 100%;
  display: flex;
`;
interface TrProps {
  isSelected: boolean;
}
export const Tr = styled.tr<TrProps>`
  border-radius: 8px;
  background-color: #f5f7fb;
  //border: solid 1px blue;
  margin-bottom: 12px;
  z-index: auto;
  display: flex;
  border-color: ${({ isSelected }) =>
    isSelected ? beam.color.primaryBlue : 'transparent'};
  border-style: solid;
  border-width: ${({ isSelected }) => (isSelected ? '1px' : '0')};
  border-color: ${({ isSelected }) =>
    isSelected ? beam.color.primaryBlue : 'transparent'};
`;
interface TdProps {
  isSelected?: boolean;
  widthPercentage: number;
}
export const Td = styled.td<TdProps>`
  width: ${({ widthPercentage }) => widthPercentage}%;
  max-width: ${({ widthPercentage }) => widthPercentage}%;
  padding-bottom: 8px;
  padding-top: 8px;
  position: relative;
  padding-left: 8px;
  overflow: hidden;
  color: #1a1b1c;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-align: start;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 48px;
  max-height: 46px;

  :after {
    content: '';
    width: 40px;
    right: 0;
    position: absolute;
    height: 38px;
    z-index: 4;
  }
`;
export const useStyles = createStyles(() => {
  return {
    td: {
      width: 'var(--width-p,28%)',
      maxWidth: 'var(--width-p,28%)',
      paddingBottom: 8,
      paddingTop: 8,
      paddingLeft: 8,
      overflow: 'hidden',
      color: '#1a1b1c',
      fontSize: 14,
      fontWeight: 400,
      cursor: 'pointer',
      height: 48,
      maxHeight: 46,
    },
  };
});
export const Label = styled.div`
  display: flex;
  align-items: center;
  color: #1a1b1c;
  font-size: 14px;
  font-weight: 400;
  background-color: transparent;
  border: none;
  gap: 16px;

  overflow: hidden;
`;

export const ImagePlaceholder = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  background-color: transparent;
  &.defaultImage {
    border: none;
  }
`;

export const PlaceholderDiv = styled.div`
  background-color: transparent;
  border: none;
`;

export const IconEdit = styled.div`
  position: absolute;
  right: 16px;
  top: 14px;
  cursor: pointer;
`;
export const User = styled.div`
  display: flex;
  align-items: center;
  color: #1a1b1c;
  font-size: 14px;
  font-weight: 400;
  column-gap: 8px;
`;

export const Avatar = styled.img`
  height: 24px;
  width: 24px;
  border-radius: 12px;
  object-fit: cover;

  [data-device='${deviceTypes.mobile}'] & {
    height: 16px;
    width: 16px;
  }
`;

interface IBody {
  widthPercentage: number;
  isActive?: boolean;
}

export const Thead = styled.thead`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 8px;
  padding-top: 5px;
  padding-bottom: 5px;

  /* Stick heading to top */
  position: sticky;
  top: 0;
  background-color: #fcfeff;
  z-index: ${zIndexes.indexOf('table-heading')};
`;

export const Th = styled.th<IBody>`
  display: flex;
  width: ${({ widthPercentage }) => widthPercentage}%;
  border: solid 1px transparent;
  border-style: solid none;
  height: 32px;
  padding-bottom: 8px;
  padding-top: 8px;
  padding-left: 8px;
  align-items: center;
  background: transparent;
  color: #8f95b2;
  position: relative;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;

  &:last-child {
    padding-right: 8px;
  }
`;

export const LoadMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const PageInfo = styled.div`
  border-radius: 8px;
  text-align: center;
  height: 40px;
  padding: 0 20px;
  color: #50525f;
  background: #efefef;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;
export const IconImgAwesome = styled(FontAwesomeIcon)`
  color: var(--beam-color-neutral-n600);
  && {
    width: 14px;
    height: 14px;
  }
  padding-left: 30px;
  box-sizing: content-box;
  /* position: sticky; */
  /* right: 16px; */
  /* top: 14px; */
  cursor: pointer;
  /* z-index: ${zIndexes.indexOf('table-heading')}; */
`;
export const TagCount = styled.div`
  border-radius: 15px;
  color: #8f95b2;
  padding: 0 10px;
  height: 24px;
  display: flex;
  align-items: center;
  margin-left: 8px;
  border: none;
  background: #edeff4;
  font-size: 14px;
  font-weight: 500;
  /* identical to box height */
  text-align: center;
  /* beam texts/logo text */
`;

export const EmptyValue = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
`;

interface IProductsTable {
  'data-configlen': number;
}

export const ListProductsTable = styled(TableFilled)<IProductsTable>`
  && {
    --row-height: 46px;
    --one-cell: ${({ 'data-configlen': configLen }) => 66 / configLen}%;
    --row-len: 5;
    --row-bg-hover: var(--beam-color-neutral-n100);
    --border-selected: 1px solid var(--beam-color-blue-b401);
    --heading-background: #fff;
    --row-block-padding: 4px;

    [data-device='${deviceTypes.mobile}'] & {
      --row-height: 34px;
      min-width: 1052px;
    }

    th[data-fieldname='Tags'] {
      width: 28%;
    }
    th {
      width: var(--one-cell);

      ${FieldHeaderWrap} {
        padding-right: 8px;
      }
    }
    th.first {
      width: calc((var(--one-cell)) + 4%);
    }
    th[data-fieldname='productName'] {
      width: calc((var(--one-cell)) + 6%);
    }
    th[data-fieldname='Tags'] {
      ${FieldHeaderWrap} {
        padding-right: 16px;
      }
    }

    table tbody tr td > .Table_content {
      cursor: pointer;
    }

    table tbody tr[data-selected='true'] td > .Table_content {
      --row-height: 47px;
      border-top: var(--border-selected);
      border-bottom: var(--border-selected);
    }
    table tbody tr[data-selected='true'] td:first-of-type > .Table_content {
      border-left: var(--border-selected);
    }
    table tbody tr[data-selected='true'] td:last-of-type > .Table_content {
      border-right: var(--border-selected);
    }
  }

  ${Label} {
    height: 100%;
  }
`;
export const ListProductsScrollArea = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;

  & .loadmore_wrap {
    padding-top: 12px;
    [data-device='${deviceTypes.mobile}'] & {
      min-width: 1052px;
    }
  }
`;
export const CellTextText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  max-width: min-content;
` as TextType;

export const FieldHeaderText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  max-width: min-content;
  text-overflow: ellipsis;
` as TextType;

export const FieldTextArrowGroup = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%;
`;
